import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, tap } from 'rxjs';
import { CompareExportsModule } from 'src/app/extensions/compare/exports/compare-exports.module';
import { OrderTemplatesExportsModule } from 'src/app/extensions/order-templates/exports/order-templates-exports.module';
import { RatingExportsModule } from 'src/app/extensions/rating/exports/rating-exports.module';
import { WishlistsExportsModule } from 'src/app/extensions/wishlists/exports/wishlists-exports.module';

import { FeatureToggleDirective } from 'ish-core/directives/feature-toggle.directive';
import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { AppFacade } from 'ish-core/facades/app.facade';
import { ProductContextDisplayProperties, ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { Image } from 'ish-core/models/image/image.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ProductHelper } from 'ish-core/models/product/product.model';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';
import { ProductAddToBasketComponent } from 'ish-shared/components/product/product-add-to-basket/product-add-to-basket.component';
import { ProductImageComponent } from 'ish-shared/components/product/product-image/product-image.component';
import { ProductLabelComponent } from 'ish-shared/components/product/product-label/product-label.component';
import { ProductNameComponent } from 'ish-shared/components/product/product-name/product-name.component';
import { ProductPriceComponent } from 'ish-shared/components/product/product-price/product-price.component';
import { ProductMarketingLabelComponent } from 'ish-shared/dias/components/product/product-marketing-label/product-marketing-label.component';

@Component({
  selector: 'custom-dot-cms-uve-product-tile',
  templateUrl: './dot-cms-uve-product-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ProductImageComponent,
    ProductLabelComponent,
    ProductNameComponent,
    ProductMarketingLabelComponent,
    ProductPriceComponent,
    ProductAddToBasketComponent,
    FeatureToggleDirective,
    OrderTemplatesExportsModule,
    WishlistsExportsModule,
    CompareExportsModule,
    TranslateModule,
    ServerHtmlDirective,
    RatingExportsModule,
  ],
})
export class DotCmsUveProductTileComponent implements OnInit {
  readonly layout = input<string>(undefined);
  product$: Observable<ProductView>;
  isMasterProduct = false;
  isPopupVisible = true;
  variationCount$: Observable<number>;
  deviceType$: Observable<DeviceType>;
  constructor(private context: ProductContextFacade, private appFacade: AppFacade) {}

  ngOnInit() {
    this.deviceType$ = this.appFacade.deviceType$;
    this.product$ = this.context.select('product').pipe(
      tap(product => {
        this.isMasterProduct = ProductHelper.isMasterProduct(product);
      })
    );
    this.variationCount$ = this.context.select('variationCount');
  }

  configuration$(key: keyof ProductContextDisplayProperties) {
    return this.context.select('displayProperties', key);
  }

  openQuickView(productSku: string) {
    this.appFacade.openQuickView(productSku);
  }

  getImagesViews(product: ProductView): string[] {
    const images: Image[] = product?.images?.filter(image => image.typeID === 'M');
    const imageViews: string[] = [];

    images?.every((image, index) => {
      if (index > 1) {
        return false;
      }

      if (image.primaryImage) {
        imageViews.unshift(image.viewID);
      } else {
        imageViews.push(image.viewID);
      }

      return true;
    });

    if (!imageViews.length) {
      imageViews.push('');
    }
    if (imageViews.length === 1) {
      imageViews.push(imageViews[0]);
    }
    return imageViews;
  }
}
